// extracted by mini-css-extract-plugin
export default {"banner":"CookieConsent_banner__bik0l","button":"CookieConsent_button__ydpY5","closeButton":"CookieConsent_closeButton__D2WP4"};